import React, { useEffect, useRef, useState } from 'react'
import {
  Popconfirm,
  Radio,
  Input,
  Table,
  message,
  Col,
  Row,
  ConfigProvider,
  Pagination,
  Button,
  Modal,
  Checkbox
} from 'antd'
import type { CheckboxChangeEvent } from 'antd/es/checkbox';
import AddStudentModal from './components/AddStudentModal/AddStudentModal'
import { BACKEND_API_URL } from '../../../constants/constants';
import { sendHttpPostRequest } from '../../../api/http-request'
import teacherStudentStyles from './course-main-teacher-student.module.less'
import globalStyles from "../../common/global-styles/idatacourse-table.module.less"
import moduleStyles from '../../oam/module/module.module.less'
import '../course.module.css'
import zhCN from 'antd/lib/locale/zh_CN'
import shiyanEmpty from '../../../static/image/empty/queshengye-shiyan.png'
import caseStyles from '../../case/case.module.less'
import slidesStyles from '../slides/course-main-teacher-slides.module.less'

import {
  DeleteOutlined,
  SettingOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import GlobalCss from '@/global.module.less'

import Draggable from 'react-draggable'
import courseMainStyles from '../course-main.module.less'
import Cookies from 'js-cookie'
import { getCollegeId } from '../../../component/modal/teacher-authenticate/teacher-authenticate'
import ModalDrag from 'component/ModaDrag/ModalDrag'

import Icon from '@ant-design/icons'
import  {ReactComponent as myplusSvg }   from '../../../static/image/course/myplus.svg'
const myplusIcon = (props:any) => (<Icon component={myplusSvg} {...props} />)

import  {ReactComponent as applylistSvg }   from '../../../static/image/course/applylist.svg'
const applylistIcon = (props:any) => (<Icon component={applylistSvg} {...props} />)
import  {ReactComponent as resetSvg }   from '../../../static/image/course/reset.svg'
const resetIcon = (props:any) => (<Icon component={resetSvg} {...props} />)

import { ReactComponent as mysettingSvg }   from '../../../static/image/course/mysetting.svg'
import { ReactComponent as deleteSvg }   from '../../../static/image/module/delete.svg'
import { ReactComponent as manSvg }   from '../../../static/image/course/man.svg'
import { ReactComponent as womanSvg }   from '../../../static/image/course/woman.svg'
import { ReactComponent as genderUnknownSvg }   from '../../../static/image/course/unknown.svg'

const manIcon = (props:any) => (<Icon component={manSvg} {...props} />)
const womanIcon = (props:any) => (<Icon component={womanSvg} {...props} />)
const genderUnknownIcon = (props:any) => (<Icon component={genderUnknownSvg} {...props} />)

const mysettingIcon = (props:any) => (<Icon component={mysettingSvg} {...props} />)

const deleteIcon = (props:any) => (<Icon component={deleteSvg} {...props} />)


import  {ReactComponent as mydeleteSvg }   from '../../../static/image/course/mydelete.svg'
const mydeleteIcon = (props:any) => (<Icon component={mydeleteSvg} {...props} />)





export interface Props {
  course_id: any,
  assistant: any,
  is_course_teacher: any,
  user_id: any,//当前课程的教师id
  teacher_id: any,//所有教师的id
  actionCallback:any,
}
/** 教师课程主页面 */
export const CourseMainTeacherStudent: React.FC<Props> = (props) => {
  const { course_id, assistant, is_course_teacher,user_id,teacher_id,actionCallback } = props
  const [selectedRowKeys, setSelectedRowKeys] = React.useState([])
  const [studentList, setStudentList] = useState([] as any[])
  const [applyList, setApplyList] = useState([] as any[])
  const [searchStuList, setSearchStuList] = useState([] as any[])
  const [showStudentList, setShowStudentList] = useState(true)
  const [totalCount, setTotalCount] = useState(0)
  const [totalSum, setTotalSum] = useState(0)

  const order = useRef('') // 排序升序降序
  const order_by = useRef('') // 排序列
  const roleFilters = useRef([]) // 角色过滤选项

  const [collegeId, setCollegeId] = useState(0)
  const [applyListModalVisible, setAplyListModalVisible] = useState(false) 


  const courseStudentQueryContent = useRef('') // 搜索 教室内成员搜索关键字

  const [selectedApplyRows, setSelectedApplyRows] = React.useState([]) //申请列表选择的行

  const page = useRef(1) // 记录当前的页数
  const pageSize = useRef(12) // 记录当前每页展示数量

  // 添加学生拖拽框变量

  const [addStudentModalVisible, setAddStudentModalVisible] = useState(false) 
  const draggleRef = useRef<HTMLDivElement | null>(null)

  const [resetPasswordModalVisible, setResetPasswordModalVisible] = useState(false)



  const [applyBounds, setApplyBounds] = useState({ left: 0, top: 0, bottom: 0, right: 0 })
  const [applyDisabled, setApplyDisabled] = useState(true)
  const draggleApplyRef = useRef<HTMLDivElement | null>(null)


  const onStartApply = (event: any, uiData: any) => {
    const { clientWidth, clientHeight } = window?.document?.documentElement
    const targetRect = draggleApplyRef?.current?.getBoundingClientRect()
    if (targetRect) {
      setApplyBounds({
        left: -targetRect?.left + uiData?.x,
        right: clientWidth - (targetRect?.right - uiData?.x),
        top: -targetRect?.top + uiData?.y,
        bottom: clientHeight - (targetRect?.bottom - uiData?.y),
      })
    }
  }


  const onChange = (e: CheckboxChangeEvent) => {
    //console.log(`checked = ${e.target.checked}`);
    //console.log(e.target?.user);


    if(e.target.checked){
      //selectedRowKeys.push(e.target.user.user_id)
      setSelectedRowKeys([...selectedRowKeys, e.target.user.user_id])
    }else {
    const newArr = selectedRowKeys.filter(item => item !== e.target?.user?.user_id);
    setSelectedRowKeys(newArr)

    }

    console.log(selectedRowKeys);
  };


  useEffect(() => {
    console.log('teacher_id', teacher_id);
    console.log('user_id', user_id);
    
    sendHttpPostRequest(
      'account/api/query_teacher_authenticate',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
      },
      (response: any) => {
        if (response?.college_info?.college_id) {
          setCollegeId(response.college_info.college_id)
        }
      }
    )
    queryCourseStudent()
    queryCourseApply()

  }, [])

  const queryCourseStudentCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      setStudentList(response.query_list)
      setTotalCount(response.query_list.length)
      setTotalSum(response.total_sum)
    } else {
      message.error(response.message)
    }
  }

  const queryCourseStudent = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        college_id: getCollegeId(),
        course_id: course_id,
        type: 0,
        query:courseStudentQueryContent.current,
        page: page.current,
        pagesize: pageSize.current,
        order: order.current,
        order_by: order_by.current,
        role: JSON.stringify(roleFilters.current),

      },
      queryCourseStudentCallback
    )
  }

  const queryCourseApplyCallback = (response: any) => {
    message.destroy()
    if (response.code == -100) {
      // 没登录
      sessionStorage.setItem("previousurl",window.location.href )
      document.getElementById('show-login-modal')!.click()
      // window.location.href = '/login?next=course';
    } else if (response.code == -501) {
      // 没权限
      message.error('权限不足')
      // window.location.href = '/login?next=course';
    } else if (response.is_ok == true) {
      setApplyList(response.query_list)
      setTotalCount(response.query_list.length)
    } else {
      message.error(response.message)
    }
  }

  //页码和页数发生了变化
  const onPageChange = (newPage: number, newPageSize?: number | undefined) => {
    page.current = newPage ? newPage : 1
    if (newPageSize) {
      pageSize.current = newPageSize
    }
    queryCourseStudent()
    setSelectedRowKeys([])
  }





  const queryCourseApply = () => {
    sendHttpPostRequest(
      'course/api/user_query_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        college_id: getCollegeId(),
        course_id: course_id,
        type: 1,
      },
      queryCourseApplyCallback
    )
  }

  const onAddCourseUserClick = (userId: number, userRole: string) => {
    console.log(userId, userRole)
    sendHttpPostRequest(
      'course/api/teacher_add_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        college_id: collegeId,
        user_list: JSON.stringify([
          { user_id: userId, user_role: parseInt(userRole) },
        ]),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=course';
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
          // window.location.href = '/login?next=course';
        } else if (response.is_ok) {
          message.success('添加成功')
          queryCourseStudent()
          const newSearchStuList = searchStuList.filter(
            (item) => item.user_id !== userId
          )
          setSearchStuList(newSearchStuList)
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const [selectedRole, setSelectedRole] = useState(null);
  const [popconfirmVisible, setPopconfirmVisible] = useState({});
  const handleIconClick = (e, record) => {
    console.log('record', record);
    setPopconfirmVisible((prevVisibleMap) => ({
      ...prevVisibleMap,
       [record.user_id]: true
     }));
    if(record && record.is_assistant !== undefined){
      setSelectedRole(record.is_assistant.toString());
    }
  }


  //设置助教
  const handleRadioChange = (e, record) => {
    console.log('record', record);
    setPopconfirmVisible((prevVisibleMap) => ({
      ...prevVisibleMap,
       [record.user_id]: false
     }));
    setSelectedRole(e.target.value);
    let student_id = record.user_id;
    let is_assistant = e.target.value;
    sendHttpPostRequest(
      'course/api/set_student_role',
      {
        course_id: course_id,
        student_id: student_id,
        is_assistant: is_assistant,
      },
      (response: any) => {
        if (response.code == 0) {
          queryCourseStudent()
        }else{
          message.error(response.message)
        }
      }
    )
  };
  // 删除成员
  const onRemoveCourseUserClick = (user_id: any) => {
    sendHttpPostRequest(
      'course/api/teacher_remove_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        college_id: collegeId,
        user_id_list: JSON.stringify([user_id]),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=course';
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
          // window.location.href = '/login?next=course';
        } else if (response.is_ok == true) {
          if (response.fail_list.length > 0) {
            let _errorMessage = `以下成员删除失败：`
            for (let _failItem in response.fail_list) {
              _errorMessage +=
                ' 用户ID：' +
                response.fail_list[_failItem]['user_id'] +
                '，失败原因： '
              _errorMessage += response.fail_list[_failItem]['fail_reason']
              _errorMessage += `；`
            }
            message.error(_errorMessage)
            setTimeout(function () {
              queryCourseStudent()
            }, 2000)
          } else {
            message.success('删除成功')
            setTimeout(function () {
              queryCourseStudent()
            }, 2000)
          }
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 批量删除成员
  const onRemoveCourseUserList = (user_id_list: any) => {
    sendHttpPostRequest(
      'course/api/teacher_remove_course_user',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        college_id: collegeId,
        user_id_list: JSON.stringify(user_id_list),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=course';
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
          // window.location.href = '/login?next=course';
        } else if (response.is_ok == true) {
          if (response.fail_list.length > 0) {
            let _errorMessage = `以下成员删除失败：`
            for (let _failItem in response.fail_list) {
              _errorMessage +=
                ' 用户ID：' +
                response.fail_list[_failItem]['user_id'] +
                '，失败原因： '
              _errorMessage += response.fail_list[_failItem]['fail_reason']
              _errorMessage += `；`
            }
            message.error(_errorMessage)
            setTimeout(function () {
              queryCourseStudent()
            }, 2000)
          } else {
            message.success('删除成功')
            setTimeout(function () {
              queryCourseStudent()
            }, 2000)
          }
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 点击拒绝
  const rejectStudentApplys = (user_id_list: any) => {
    sendHttpPostRequest(
      'course/api/teacher_reject_user_course_apply',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        user_id_list: JSON.stringify(user_id_list),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()
          // window.location.href = '/login?next=course';
        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
        } else if (response.is_ok == true) {
          const newApplyList = applyList.filter(
            (item) => user_id_list.indexOf(item.user_id) < 0
          )
          setApplyList(newApplyList)
          setSelectedApplyRows([])
          message.success('已拒绝')
          actionCallback && actionCallback()
          queryCourseStudent()
        } else {
          message.error(response.message)
        }
      }
    )
  }

  // 点击通过
  const approveStudentApplys = (user_id_list: any) => {
    sendHttpPostRequest(
      'course/api/teacher_approve_user_course_apply',
      {
        sessionid: Cookies.get('sessionid'),
        sid: Cookies.get('sessionid'),
        course_id: course_id,
        user_id_list: JSON.stringify(user_id_list),
      },
      (response: any) => {
        message.destroy()
        if (response.code == -100) {
          // 没登录
          sessionStorage.setItem("previousurl",window.location.href )
          document.getElementById('show-login-modal')!.click()

        } else if (response.code == -501) {
          // 没权限
          message.error('权限不足')
        } else if (response.is_ok == true) {
          const newApplyList = applyList.filter(
            (item) => user_id_list.indexOf(item.user_id) < 0
          )
          setApplyList(newApplyList)
          setSelectedApplyRows([])
          message.success('已同意')
          actionCallback && actionCallback()
          queryCourseStudent()
        } else {
          message.error(response.message)
        }
      }
    )
  }

  const rowSelection = {
    selectedRowKeys,
    getCheckboxProps: record => ({
      disabled: 
      (user_id == teacher_id && user_id == record?.user_id) 
      || (user_id !== teacher_id && record?.role=="教师") 
      || (assistant && record?.role!=="学生")
    }),
    onChange: (keys) => {
      setSelectedRowKeys(keys)
    },
  }


  const rowApplySelection = {
    selectedApplyRows,
    onChange: (keys, rows) => {
      console.log(rows)
      setSelectedApplyRows(rows)
    },
  }

  const resetPassWordOk = () => {
    let url = 'course/api/batch_reset_user_password'
    let params = {
      user_id_list: JSON.stringify(selectedRowKeys),
    }
    sendHttpPostRequest(url, params, (res) => {
      if (res.code == 0) {
        message.success('重置成功~')
      } else {
        message.error(res.msg)
      }
    })
    setResetPasswordModalVisible(false)
  }

  const renderChoose = (e) => {
    return (
      <>
        <span style={{ marginLeft: 5 }}>{e < 10 ? '0' + e : e}</span>
      </>
    )
  }

  // 渲染操作
  const renderStudentActions = (text: any, record: any) => {
    return (
      <div>
        <Popconfirm
          key={record.user_id}
          open={popconfirmVisible[record.user_id] && record.isSelected && (record.role!=="教师")}
          title={
            <div>
              <div>设置身份为：</div>
              <Radio.Group value={selectedRole} onChange={(e) => handleRadioChange(e, record)}>
                <Radio value='0'>学生</Radio>
                <Radio value='1'>助教</Radio>
              </Radio.Group>
            </div>
          }
          // 禁用确认和取消按钮的默认行为
          okButtonProps={{ style: { display: 'none' } }}
          cancelButtonProps={{ style: { display: 'none' } }}
          //去除感叹号的图标样式
          icon={null}
        >
          <SettingOutlined
            style={{
              display: (assistant ? 'none' : ''),
              paddingRight:16,
            }}
            className={record?.role=="教师" ? teacherStudentStyles.noHighlightIcon : teacherStudentStyles.actionBtn}
            onClick={record?.role!=="教师" ? (e) => handleIconClick(e, record) : (e) => {setPopconfirmVisible((prevVisibleMap) => ({
              ...prevVisibleMap,
               [record.user_id]: false
             }));}}
          />
        </Popconfirm>
        <Popconfirm
          key={record.user_id}
          open={popconfirmVisible[record.user_id] && record.isSelected && (record.role!=="教师")}
          placement="top"
          title={'确认删除成员"' + record.name + '"吗？'}
          okText="确认"
          cancelText="取消"
          onConfirm={onRemoveCourseUserClick.bind(this, record.user_id)}
        >
        <DeleteOutlined 
          className={((user_id == teacher_id && user_id == record?.user_id) || (user_id !== teacher_id && record?.role=="教师") || (assistant && record?.role!=="学生")) ? teacherStudentStyles.noHighlightIcon : teacherStudentStyles.actionBtn}
          onClick={
            (
              (user_id == teacher_id && user_id == record?.user_id) 
              || (user_id !== teacher_id && record?.role=="教师") 
              || (assistant && record?.role!=="学生")
            ) ? (e) => {setPopconfirmVisible((prevVisibleMap) => ({
            ...prevVisibleMap,
             [record.user_id]: false
           }));} : (e) => {}
          }
          />
      </Popconfirm>
      </div>
    )
  }




  // 渲染操作
  const renderApplyActions = (text: any, record: any) => {
    return (
      <div>
        {(assistant || is_course_teacher)&& (
          <Button
            className={teacherStudentStyles.refuseBtn}
            style={{ marginRight: 0, marginLeft:0, width:40}}
            size="small"
            type="link"
            onClick={() => {
              rejectStudentApplys([record.user_id])
            }}
          >
            {' '}
            拒绝{' '}
          </Button>
        )}
        {(assistant || is_course_teacher) && (
          <Button
            className={teacherStudentStyles.actionBtn}
            style={{  marginRight: 0, marginLeft:0, width:40}}
            size="small"
            type="link"
            onClick={() => {
              approveStudentApplys([record.user_id])
            }}
          >
            {' '}
            同意{' '}
          </Button>
        )}
      </div>
    )
  }

  const applyCols: any = [
    {
      title: '全选',
      dataIndex: 'user_id',
      key: 'user_id',
      align: 'left',
      ellipsis: true,
      width: 80,
      render: (text, record, index) => index + 1,
    },
    {
      title: '姓名',
      dataIndex: 'name',
      key: 'name',
      align: 'left',
      ellipsis: true,
      width: 120,
      render: (t, r, i) => {
        return (
        <Row align="middle" justify="start" style={{ gap: '5px' }}>
            <Col>
            <img
                className={GlobalCss.avatar}
                src={BACKEND_API_URL + r.avatar}
            />
            </Col>
            <Col>{r.real_name !== ''? r.real_name : t}</Col>
        </Row>
        )
      },
    },
    {
      title: '账号',
      dataIndex: 'phone',
      key: 'phone',
      align: 'center',
      ellipsis: true,
      width: 150,
      render: (t, r, i) => {return r?.register_type == 1 ? r?.phone: r?.email}
    },
    {
      title: '申请时间',
      dataIndex: 'apply_time',
      key: 'apply_time',
      align: 'center',
      ellipsis: true,
      width: 150,
    },

    {
      title: '操作',
      dataIndex: 'actions',
      key: 'actions',
      width: 100,
      ellipsis: true,
      align: 'center',
      render: renderApplyActions,
    },
  ]



  // 教师搜索教室内成员
  const onSearchCourseUserValueChange = (event: any) => {
    courseStudentQueryContent.current = event.target.value

  }

  const onSearchCourseUserBtn = (e: any) => {
    page.current = 1
    queryCourseStudent()
  }


  return (
    <div>
  
        <div>
          <Row align={'middle'} justify={'end'} style={{marginBottom:24,  gap: '10px' }}>

            <Col flex='auto' style={{ textAlign: 'left' }}>

              <Input
                onPressEnter={onSearchCourseUserBtn}
                onChange={onSearchCourseUserValueChange}
                placeholder="请输入成员姓名或账号..."
                className={caseStyles.searchInput}
                style={{padding:8}}
                suffix={<SearchOutlined style={{ color: '#666666' }} />}
              />

            </Col>

            <Col flex='500px' style={{ textAlign: 'right' }} >

              {applyList?.length > 0 && <span style={{marginRight:5, display:'inline-block', fontSize:14, color:"#4b5563"}}> {applyList?.length}个申请  </span>}
               <span
                    style={{fontSize:14, padding:'4px 12px'}}
                    className={courseMainStyles.BtnDark}
                    onClick={() => {setAplyListModalVisible(true)}}
                >
                  <Icon component={applylistIcon}/> 申请列表
                </span> 
              

                <span
                    style={{fontSize:14, padding:'4px 12px', marginLeft:12}}
                    className={courseMainStyles.BtnDark}
                    onClick={() => {setAddStudentModalVisible(true)}}
                >
                  <Icon component={myplusIcon}/> 添加成员
                </span> 


               { selectedRowKeys?.length == 0 ?  <span
                    style={{fontSize:14, padding:'4px 12px', marginLeft:12,width:100}}
                    className={courseMainStyles.BtnDisableGray}
                >
                  <Icon component={resetIcon}/> 重置密码
                </span> : <span
                    style={{fontSize:14, padding:'4px 12px', marginLeft:12,width:100}}
                    className={courseMainStyles.BtnDefault}
                    onClick={() => {setResetPasswordModalVisible(true)}}
                >
                  <Icon component={resetIcon}/> 重置密码
                </span>
              } 


              {  selectedRowKeys?.length == 0 ? <span
                  style={{fontSize:14, padding:'4px 12px', marginLeft:12,width:100}}
                  className={courseMainStyles.BtnDisableGray}

              >
                <Icon component={deleteIcon}/> 批量删除
              </span> :
              <Popconfirm
                  trigger={"click"}
                  placement="top"
                  title={'确认删除选中的 ' + selectedRowKeys.length + ' 个成员吗？'}
                  okText="确认"
                  cancelText="取消"
                  onConfirm={() => {onRemoveCourseUserList(selectedRowKeys)}}
                >
              <span
                  style={{fontSize:14, padding:'4px 12px', marginLeft:12,width:100}}
                  className={courseMainStyles.BtnDelete}
                 
              >
                <Icon component={deleteIcon}/> 批量删除
              </span> 
              </Popconfirm>
              }

            </Col>
          </Row>

          <Row gutter={[24, 24]} justify="start"  align="middle" wrap={true}>
            {studentList?.map((sudent:any, studentIndex) => {
              return (
                <Col span={8} key={sudent?.user_id}>
                  <div 
                    className={teacherStudentStyles.userCard} style={{height:'100%', width:'100%',border:selectedRowKeys.includes(sudent.user_id)? '1px solid #07c160': '1px solid #e5e7eb'}}
                  >

                    <Row wrap={false} align={"top"} >
                      <Col flex={"64px"} style={{marginRight:16}}>
                        <div>
                            <img
                              src={BACKEND_API_URL + sudent?.avatar}
                              style={{height:'64px', width:'64px', borderRadius:8}}
                            />
                        </div>
                      </Col>

                      <Col flex={"auto"} style={{textAlign:'left'}}>
                        <div>
                          <div className={teacherStudentStyles.userCardName}>{sudent?.real_name !== ''? sudent.real_name : sudent?.name}</div>
                          <div>
                            <span className={teacherStudentStyles.userCardRoleLabel} style={{color:sudent?.role == '教师'? "#07c160": sudent?.role == '助教'? "#2563EB":'#4b5563' , background:sudent?.role == '教师'? "#E6F7EF":sudent?.role == '助教'?'#DBEAFE':'#f3f4f6'}}>{sudent?.role}</span>

                            <span style={{marginLeft:8}}><Icon  component={sudent?.sex==2? manIcon:sudent?.sex==3?womanIcon:genderUnknownIcon}/></span>
                            <span style={{color:"#6b7280", fontSize:14,marginLeft:3}}>{sudent?.sex==2?"男":sudent?.sex==3?"女":'未知' }</span>
                          </div>
                        </div>
                      </Col>

                      <Col flex={"64px"} >
                        <div style={{textAlign:'right'}}>
                          <Checkbox 
                            id={sudent?.phone} 
                            user={sudent}
                            disabled={sudent?.user_id == teacher_id}
                            
                            onChange={onChange}></Checkbox></div>
                      </Col>
                    </Row>

                    <div className={teacherStudentStyles.userCardContentDiv}>
                      <Row wrap={false} align={"middle"}>
                        <Col flex={"100px"}>
                          <div className={teacherStudentStyles.userCardContentItem}>
                              账号
                          </div>
                        </Col>
                        <Col flex={"auto"}>
                          <div className={teacherStudentStyles.userCardContentValue}>
                            {sudent?.register_type == 1 ?  sudent?.phone : sudent?.email}
                          </div>
                        </Col>
                      </Row>

                      <Row wrap={false} align={"middle"} style={{margin:'8px 0 0'}}>
                        <Col flex={"100px"}>
                          <div className={teacherStudentStyles.userCardContentItem}>
                              学号/工号
                          </div>
                        </Col>
                        <Col flex={"auto"}>
                          <div className={teacherStudentStyles.userCardContentValue}>
                             {sudent?.number}
                          </div>
                        </Col>
                      </Row>

                      <Row wrap={false} align={"middle"} style={{margin:'8px 0 0'}}>
                        <Col flex={"100px"}>
                          <div className={teacherStudentStyles.userCardContentItem}>
                              加入时间
                          </div>
                        </Col>
                        <Col flex={"auto"}>
                          <div className={teacherStudentStyles.userCardContentValue}>
                            {sudent?.join_time}
                          </div>
                        </Col>
                      </Row>
                    </div>

                    <div className={teacherStudentStyles.userCardActionDiv}>

                        { !assistant && sudent?.user_id !== teacher_id ? <Popconfirm                      
                          open={popconfirmVisible[sudent.user_id] && sudent.isSelected && (sudent.role!=="教师")}
                          title={
                            <div>
                              <div>设置身份为：</div>
                              <Radio.Group value={selectedRole} onChange={(e) => handleRadioChange(e, sudent)}>
                                <Radio value='0'>学生</Radio>
                                <Radio value='1'>助教</Radio>
                              </Radio.Group>
                            </div>
                          }
                          // 禁用确认和取消按钮的默认行为
                          okButtonProps={{ style: { display: 'none' } }}
                          cancelButtonProps={{ style: { display: 'none' } }}
                          //去除感叹号的图标样式
                          icon={null}
                        >
                          <span
                           title="角色设置"
                            className={slidesStyles.actionIconWrapper}
                            onClick={sudent?.role!=="教师" ? (e) => handleIconClick(e, sudent) : (e) => {setPopconfirmVisible((prevVisibleMap) => ({
                              ...prevVisibleMap,
                              [sudent.user_id]: false
                            }));}}
                          >
                            <Icon component={mysettingIcon}/>
                          </span>
                        </Popconfirm>  : 
                        <span 
                          className={slidesStyles.actionIconWrapper} 
                          style={{marginLeft:0,background:'#fff',cursor:"not-allowed"}}><Icon component={mysettingIcon}/></span>
                        }

                        {
                          sudent?.user_id == teacher_id ? 
                          <span 
                          className={slidesStyles.deleteIconWrapper} 
                          style={{marginLeft:0,background:'#fff',cursor:"not-allowed"}}><Icon component={mydeleteIcon}/></span>:
                        
                        <Popconfirm
                          key={sudent.user_id}
                          open={popconfirmVisible[sudent.user_id] && sudent.isSelected && (sudent.role!=="教师")}
                          placement="top"
                          title={'确认删除成员"' + sudent.name + '"吗？'}
                          okText="确认"
                          cancelText="取消"
                          onConfirm={onRemoveCourseUserClick.bind(this, sudent.user_id)}
                        >

                          <span title="删除" 
                            style={{marginLeft:0}}
                            className={slidesStyles.deleteIconWrapper} 
                            onClick={
                              (
                                (user_id == teacher_id && user_id == sudent?.user_id) 
                                || (user_id !== teacher_id && sudent?.role=="教师") 
                                || (assistant && sudent?.role!=="学生")
                              ) ? (e) => {setPopconfirmVisible((prevVisibleMap) => ({
                              ...prevVisibleMap,
                              [sudent.user_id]: false
                            }));} : (e) => {}
                            }
                          ><Icon component={mydeleteIcon}/></span> 

                      </Popconfirm>
                    }

                    </div>
                </div>
                </Col>
              )
            })}
          </Row>

          {studentList.length == 0 && (
            <div style={{ textAlign: 'center', paddingTop: 20 }}>
              <img src={shiyanEmpty} width={120} height={120} />
              <div style={{ color: '#999', marginTop: 10 }}>
                没有找到或没有成员~
              </div>
            </div>
          )}



            <ConfigProvider locale={zhCN}>
              <Pagination
                style={{ marginTop: 20 }}
                size={'default'}
                defaultCurrent={1}
                total={totalSum}
                hideOnSinglePage={true}
                current={page.current}
                onChange={onPageChange}
                defaultPageSize={pageSize.current}
              />
            </ConfigProvider>
          
        </div>
    
        <ConfigProvider locale={zhCN}>
        <Modal
          title={
            <div
              style={{ width: '100%', cursor: 'move' }}
              onMouseOver={() => {
                if (applyDisabled) {
                  setApplyDisabled(false)
                }
              }}
              onMouseOut={() => {
                setApplyDisabled(true)
              }}
              onFocus={() => {}}
              onBlur={() => {}}
            >
              申请列表
            </div>
          }
          open={applyListModalVisible}
          width={750}
          bodyStyle={{ minHeight: 600, overflow: 'auto', paddingBottom:10 }}
          //onOk={()=>{}}
          footer={null}
          onCancel={() => {setAplyListModalVisible(false)}}
          destroyOnClose={true}
          closable={true}
          modalRender={(modal) => (
            <div className={moduleStyles.addModal}>
              <Draggable
                disabled={applyDisabled}
                bounds={applyBounds}
                onStart={(event, uiData) => onStartApply(event, uiData)}
              >
                <div ref={draggleApplyRef}>{modal}</div>
              </Draggable>{' '}
            </div>
          )}
        >
         <>
          <Row gutter={[10, 10]} justify="start" style={{marginBottom:10}}>

          <Col flex='auto' style={{ textAlign: 'left' }}>
              <Input
                onPressEnter={()=>{}}
                placeholder="请输入姓名/账号..."
                style={{ float: 'left', borderRadius: 20, width: 250 }}
                suffix={<SearchOutlined style={{ color: '#666666' }} />}
                onChange={()=>{}}
              />
            </Col>


            <Col flex={"300"} style={{ textAlign: 'right'}}>
              <Button
                disabled={selectedApplyRows?.length == 0}
                type="primary"
                className={teacherStudentStyles.refuse}
                style={{
                  textShadow:'none',
                  boxShadow:'none',
                  backgroundColor: '#FF4B50',
                  borderColor: '#FF4B50',
                  borderRadius: 20,
                  width: 64,
                  height: 32,
                  marginLeft:10,
                  marginRight:0,
                }}
                onClick={() => {
                  rejectStudentApplys(
                    selectedApplyRows?.map((item: any) => item.user_id)
                  )
                }}
              >
                {' '}
                拒绝{' '}
              </Button>
      
              <Button
                disabled={selectedApplyRows?.length == 0}
                type="primary"
                style={{
                  textShadow:'none',
                  boxShadow:'none',
                  borderRadius: 20,
                  width: 64,
                  height: 32,
                  marginLeft:10,
                  marginRight:0,
                }}
                onClick={() => {
                  approveStudentApplys(
                    selectedApplyRows?.map((item: any) => item.user_id)
                  )
                }}
              >
                同意{' '}
              </Button>
            </Col>
          </Row>
          <div style={{ textAlign: 'right' }}> </div>
          <div className={globalStyles.tableWrapper}>
            <ConfigProvider locale={zhCN}>
              <Table
                dataSource={applyList}
                columns={applyCols}
                size="small"
                rowKey={(record) => record.user_id}
                pagination={{
                  position: ['bottomCenter'],
                  pageSize: 10,
                  size: 'default',
                  hideOnSinglePage: true,
                  showSizeChanger:false,
                }}
                rowSelection={rowApplySelection}
              />
            </ConfigProvider>
          </div>
    
        </>
        </Modal>
      </ConfigProvider>

      {addStudentModalVisible && (
        <AddStudentModal
          theme={'dark'}
          open={addStudentModalVisible}
          setOpen={setAddStudentModalVisible}
          onCancel={() => {
            setAddStudentModalVisible(false)
          }}
          college_id={collegeId}
          course_id={course_id}
          actionCallback={queryCourseStudent}
        />
      )}

      <ModalDrag
        width={460}
        open={resetPasswordModalVisible}
        modalContent={
          <Row
            align={'middle'}
            justify={'center'}
            style={{ width: '300px', margin: '0 auto', height: '80px' }}
            wrap={true}
          >
            <Col>
              确定要重置选中的{' '}
              <span className={GlobalCss.hlText}>{selectedRowKeys.length}</span>{' '}
              个成员的密码为
            </Col>
            <Col>
              默认密码 <span className={GlobalCss.hlText}>123456</span> ？
            </Col>
          </Row>
        }
        modalTitle={'提示'}
        onOk={resetPassWordOk}
        onCancel={() => setResetPasswordModalVisible(false)}
      />


    </div>
  )
}

export default CourseMainTeacherStudent
